<template>
  <section class="dp-layout">

    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <div class="all_page_border">
        <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

        <!-- 添加时间段切换按钮组 -->
        <div class="time-period-controls" style="margin-bottom: 16px;">
          <el-button v-for="(period, index) in (users[0] && users[0].SummaryList) || []" :key="index"
            :type="activePeriod === index ? 'primary' : 'default'" @click="handlePeriodClick(index)">
            {{ period.DepartmentName }}
          </el-button>
        </div>

        <!-- 列表 - 修改为只显示当前选中的时间段 -->
                <el-table v-loading="listLoading" :data="users">
          <!-- 基础信息列 -->

          <el-table-column prop="DepartmentName" label="部门" width header-align="center"
            align="center"></el-table-column>
          <el-table-column prop="TerminalName" label="终端名称" width header-align="center"
            align="center"></el-table-column>
          <el-table-column prop="DeviceSerialNo" label="终端序列号" width header-align="center"
            align="center"></el-table-column>
          <el-table-column prop="InstallAddress" label="安装位置" width header-align="center"
            align="center"></el-table-column>

          <!-- 只显示当前选中的时间段数据 -->
          <el-table-column v-if="activePeriodData" :label="activePeriodData.DepartmentName" header-align="center">

            <el-table-column prop="TotalCount" label="消费总笔数" width header-align="center" align="center">
              <template slot-scope="scope">{{ scope.row.SummaryList[activePeriod].TotalCount }}</template>
            </el-table-column>

            <el-table-column prop="TotalMoney" label="消费总金额" width header-align="center" align="center">
              <template slot-scope="scope">{{ scope.row.SummaryList[activePeriod].TotalMoney.toFixed(2) }}</template>
            </el-table-column>
            <el-table-column prop="DiscountMoney" label="优惠金额" width header-align="center" align="center">
              <template slot-scope="scope">{{ scope.row.SummaryList[activePeriod].DiscountMoney.toFixed(2) }}</template>
            </el-table-column>
            <el-table-column prop="PayMoney" label="实际支付金额" width header-align="center" align="center">
              <template slot-scope="scope">{{ scope.row.SummaryList[activePeriod].PayMoney.toFixed(2) }}</template>
            </el-table-column>
            <el-table-column prop="RevokeCount" label="撤销笔数" width header-align="center" align="center">
              <template slot-scope="scope">{{ scope.row.SummaryList[activePeriod].RevokeCount }}</template>
            </el-table-column>
            <el-table-column prop="RevokeMoney" label="撤销金额" width header-align="center" align="center">
              <template slot-scope="scope">{{ scope.row.SummaryList[activePeriod].RevokeMoney.toFixed(2) }}</template>
            </el-table-column>
          </el-table-column>
        </el-table>

        <!-- 工具条 -->
        <el-col :span="24" class="toolbar">
          <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10" :total="total"
            style="float: right"></el-pagination>
        </el-col>
      </div>

    </section>

  </section>
</template>

<script>
import util from "../../../util/date";
import { getPowerTerminalConsumptionSummary, exportPowerTerminalConsumptionSummary } from '../../api/modules/consumption';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      filters: {
      },
      searchList: [
        {
          label: '终端号',
          key: 'deviceSerialNo',
        }, {
          label: '开始日期',
          key: 'date',
          type: 'date'
        },
        {
          label: '结束日期',
          key: 'endDate',
          type: 'date'
        },
      ],
      buttonList: [],
      options: [],
      users: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      statusList: [
        { name: "激活", value: true },
        { name: "禁用", value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      isResouceShow: 0,
      DepartmentId: "",
      dialogVisible: false,
      currentDate: "",
      historyData: [],
      historyDataTotal: 0,
      historyDataPage: 1,
      historyUserId: 0,
      multipleSelection: [],

      refundDialogVisible: false,
      refundData: [],
      refundDataTotal: 0,
      refundDataPage: 1,
      activePeriod: 0, // 当前选中的时间段索引
      activePeriodData: null, // 当前选中的时间段数据
    };
  },
  computed: {
  },
  methods: {
    // 时间段切换按钮点击事件
    handlePeriodClick(index) {
      this.activePeriod = index;
      this.activePeriodData = (this.users[0] && this.users[0].SummaryList[index]) || null;
    },

    handleSelectionChange(val) {
      console.log(val);
      this.multipleSelection = val;
    },
    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.handleQuery();
    },
    callFunction(item) {
      this.currentDate = item.search.date || "";
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    // 获取用户列表 - 初始化时设置默认显示的时间段
    handleQuery() {
      let _this = this;
      let para = {
        page: this.page,
        departmentId: this.DepartmentId,
        ...this.filters
      };
      this.listLoading = true;
      getPowerTerminalConsumptionSummary(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        // 初始化默认显示第一个时间段
        if (this.users.length > 0 && this.users[0].SummaryList && this.users[0].SummaryList.length > 0) {
          this.activePeriod = 0;
          this.activePeriodData = this.users[0].SummaryList[0];
        }
        this.listLoading = false;
      });
    },

    async exportExcel() {
      try {
        let para = {
          page: this.page,
          departmentId: this.DepartmentId,
          ...this.filters
        };

        var fileName = "终端消费汇总报表";
        const response = await exportPowerTerminalConsumptionSummary(para);
        if (!response.data) {
          this.$message({
            message: "导出数据为空",
            type: "error",
          });
          return;
        }
        // 处理导出数据        
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName + '.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error('下载失败:', error);
      }
    },
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    console.log(this.buttonList); 
  },
};
</script>

<style scoped>
/* .custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
} */

</style>